// extracted by mini-css-extract-plugin
module.exports = {"error__text":"errorText-module__error__text___RUbEf","error__all":"errorText-module__error__all___Q+38A"};